<template>
  <deleted-page-component>
     <p>Something went wrong.</p>
     <p>Try again later.</p>
  </deleted-page-component>
</template>

<script>
import DeletedPage from './deleted-common.vue'
export default {
  components: {
    'deleted-page-component': DeletedPage
  }
}
</script>

<style scoped>
p {
    font-weight: 700;
    font-size: 22px;
    line-height: 28px;
    margin: 0;
}
</style>



// WEBPACK FOOTER //
// deleted-dealer.vue?5e35bfe0